export default function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-zoom/src/event.js
// module id = 508
// module chunks = 0 1